module.exports = __webpack_public_path__ + "static/media/dashboard.18b5cf82.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingPage/dashboard.png
// module id = 978
// module chunks = 0